export default __webpack_public_path__ + "static/media/tagline.4ade6dfc.png";